/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {useThemeMode} from '../../../../../../_metronic/partials';
import css from '../../../../../../styles/TOPManagers.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import imagePlug from '../../../../../../_metronic/assets/media/user.png';
import {Link} from 'react-router-dom';
import {formatNumber} from '../../../../../functions/formatNumber';

const Item = ({data, top, bad}) => {
  const store = useStore();
  const theme = useThemeMode();

  const [mode, setMode] = useState('');
  const [openSub, setOpenSub] = useState(false);

  useEffect(() => {
    if (theme.mode === 'system') {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setMode('dark');
      } else {
        setMode('light');
      }
    } else {
      setMode(theme.mode);
    }
  }, [theme]);

  return (
    <li className={css.item}>
      <div
        className={css.blockScreen}
        style={{
          backgroundColor: mode === 'light' ? 'rgb(255, 255, 255)' : '#15171C',
          border: mode === 'light' ? '1px solid rgb(241, 241, 244)' : 'none',
        }}
      >
        <div
          className={classNames(
            css.position,
            top[0] === data?.id && css.gold,
            top[1] === data?.id && css.silver,
            top[2] === data?.id && css.bronze,
            bad.includes(data?.id) ? css.bad : '',
            // !top.includes(data?.id) && !bad.includes(data?.id) ? css.borderInTable_5 : ''
          )}
        >
          <span className={classNames('text-gray-900 fw-bold fs-6 text-center')}>
            {data.place === 99999 ? '-' : data.place}
          </span>
        </div>
        <div className={css.user}>
          <div className='d-flex align-items-center'>
            <div className={classNames('symbol symbol-45px me-5')}>
              <img
              className='object-fit-cover'
                src={data?.avatar ? `${process.env.REACT_APP_API_HOST}/${data?.avatar}` : imagePlug}
                style={{borderRadius: '50%'}}
                alt=''
              />
            </div>

            <div className='d-flex justify-content-start flex-column'>
              <Link
                to={
                  store.roles.includes(4) || store.roles.includes(8) || store.roles.includes(30)
                    ? `/sales/ltc/teams/${data?.id}`
                    : ''
                }
              >
                <span className='text-gray-900 text-hover-primary fw-bold mb-1 fs-6 text-nowrap cursor-pointer'>
                  {data?.first_name} {data?.last_name}
                </span>
              </Link>
              <span className='text-muted fw-semibold text-muted d-block fs-7'>
                #{data?.id}
                <span
                  className={classNames(
                    `badge badge-light-${data?.status} ms-2 fs-7 fw-bold`,
                    css.userLtc,
                  )}
                >
                  {data?.ltc.toFixed(2)}%
                </span>
                <span
                  className={classNames(
                    `ms-2 fs-6 fw-bold text-gray-900`,
                    css.userLtc,
                  )}
                >
                  {data?.pay.toFixed(2)}$
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className={classNames(css.info, css.screenInfo)} style={{justifyContent: 'center'}}>
          <div className={css.stats}>
            <div className={classNames(css.appeals, css.separator)}>
              <div className='d-flex align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='d-flex justify-content-center align-items-center'>
                    <span className='text-gray-900 fw-bold mb-1 fs-6 text-center'>
                      {formatNumber(data?.count_users)}
                    </span>
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Сотрудников
                  </span>
                </div>
              </div>
            </div>
            <div className={classNames(css.appeals, css.separator)}>
                <div className='d-flex align-items-center'>
                  <div className='d-flex justify-content-start flex-column'>
                  <span className='d-flex justify-content-center align-items-center'>
                    <span
                      className='text-primary fw-bold mb-1 fs-6 text-center'
                      title="AVG Обращений"
                    >
                      {formatNumber(data?.average_appeals)}
                    </span>
                    <span className='text-gray-900 fw-bold mb-1 fs-6 text-center'> / </span>
                    <span
                      className='text-success fw-bold mb-1 fs-6 text-center'
                      title="Общее количество обращений"
                    >
                      {data?.count_appeals}
                    </span>
                  </span>
                    <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Обращений
                  </span>
                  </div>
                </div>
            </div>
            <div className={classNames(css.registrations, css.separator)}>
              <div className='d-flex justify-content-center align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='text-gray-900 fw-bold   d-block mb-1 fs-6 text-center'>
                    {formatNumber(data?.count_registrations)}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Регистрации
                  </span>
                </div>
              </div>
            </div>
            <div className={css.qualifications}>
              <div className='d-flex justify-content-center align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='text-gray-900 fw-bold   d-block mb-1 fs-6 text-center'>
                    {formatNumber(data?.count_qualifications)}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Квалификации
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css.ltc}>
          <span className={`badge badge-light-${data?.status} fs-7 fw-bold`}>{data?.ltc.toFixed(2)}%</span>
        </div>
        <div className={css.ltc}>
          <span className={`text-gray-900 fw-bold fs-6`}>{data?.pay.toFixed(2)}$</span>
        </div>
        <div className={css.action}>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-25px w-25px'
            onClick={() => setOpenSub(!openSub)}
          >
            {!openSub && <i className='ki-duotone ki-plus fs-3 m-0'></i>}
            {!!openSub && <i className='ki-duotone ki-minus fs-3 m-0'></i>}
          </button>
        </div>
      </div>
      <div
        className={classNames(css.blockMobile, !!openSub && css._active)}
        style={{
          backgroundColor: mode === 'light' ? 'rgb(255, 255, 255)' : '#15171C',
          border: mode === 'light' ? '1px solid rgb(241, 241, 244)' : 'none',
        }}
      >
        <div className={css.info}>
          <div className={css.stats}>
            <div className={classNames(css.appeals, css.separator)}>
              <div className='d-flex align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='d-flex justify-content-center align-items-center'>
                    <span className='text-gray-900 fw-bold mb-1 fs-6 text-center'>
                      {formatNumber(data?.count_users)}
                    </span>
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Сотрудников
                  </span>
                </div>
              </div>
            </div>
            <div className={classNames(css.registrations, css.separator)}>
              <div className='d-flex align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='d-flex justify-content-center align-items-center'>
                    <span
                      className='text-primary fw-bold mb-1 fs-6 text-center'
                      title='AVG Обращений'
                    >
                      {formatNumber(data?.average_appeals)}
                    </span>
                    <span className='text-gray-900 fw-bold mb-1 fs-6 text-center'> / </span>
                    <span
                      className='text-success fw-bold mb-1 fs-6 text-center'
                      title='Общее количество обращений'
                    >
                      {data?.count_appeals}
                    </span>
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Обращений
                  </span>
                </div>
              </div>
            </div>
            <div className={classNames(css.registrations, css.separator)}>
              <div className='d-flex justify-content-center align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='text-gray-900 fw-bold   d-block mb-1 fs-6 text-center'>
                    {formatNumber(data?.count_registrations)}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Регистрации
                  </span>
                </div>
              </div>
            </div>
            <div className={css.qualifications}>
              <div className='d-flex justify-content-center align-items-center'>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='text-gray-900 fw-bold   d-block mb-1 fs-6 text-center'>
                    {formatNumber(data?.count_qualifications)}
                  </span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                    Квалификации
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default observer(Item);
